/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Preview_LabelInputs */

const sv_embed_preview_label = /** @type {(inputs: Embed_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbäddning`)
};

const en_embed_preview_label = /** @type {(inputs: Embed_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embed`)
};

/**
* | output |
* | --- |
* | "Embed" |
*
* @param {Embed_Preview_LabelInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const embed_preview_label = /** @type {((inputs?: Embed_Preview_LabelInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Preview_LabelInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_embed_preview_label(inputs)
	return en_embed_preview_label(inputs)
});